<template>
  <AddCommandeFournisseur />
</template>

<script lang="ts">
  import AddCommandeFournisseur from "@/components/GesCom/CommandeFournisseur/AddCommandeFournisseur.vue";
  import { defineComponent } from "vue";
  
  export default defineComponent({
    name: "AddCommandeFournisseurPage",
    components: {
      AddCommandeFournisseur,
    },
  });
</script>